module.exports = __webpack_public_path__ + "img/thermometer-img3-1.e2706052.png";